import { ReactComponent as PrivacyIcon } from './privacy.svg';
import { ReactComponent as SocialIcon } from './social.svg';
import { ReactComponent as TradingIcon } from './trading.svg';

export const SvgIcons = {
  PrivacyIcon,
  SocialIcon,
  TradingIcon,
};
